import {
  Action,
  ActionType,
  PatientProfileResponse,
} from "models/bodyTemperature/patientProfile";
import createReducer from "../../createReducer";

export interface PatientProfileReducerType {
  loading: boolean;
  error?: string;
  patientProfileResponse?: PatientProfileResponse;
}

const defaultState: PatientProfileReducerType = {
  loading: false,
  error: undefined,
  patientProfileResponse: undefined,
};

export const createPatientProfileReducer =
  createReducer<PatientProfileReducerType>(defaultState, {
    [ActionType.CREATE_PATIENT_PROFILE](state: PatientProfileReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.CREATE_PATIENT_PROFILE_ERROR](
      state: PatientProfileReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.CREATE_PATIENT_PROFILE_SUCCESS](
      state: PatientProfileReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        patientProfileResponse: action.payload,
      };
    },
  });
